import { render, staticRenderFns } from "./ScreeningItemMenu.vue?vue&type=template&id=fab4de54&scoped=true&"
import script from "./ScreeningItemMenu.vue?vue&type=script&lang=js&"
export * from "./ScreeningItemMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab4de54",
  null
  
)

export default component.exports